<template>
  <div
    v-show="isVisible"
    class="timeline-item"
    :style="courseStyle"
  >
    {{ presentTime }}
  </div>
</template>

<script>
import HourMinutes from "./hourMinutes";

export default {
	name: "TimelineItem",
	props: {
		courseStartEndTime: {},
		blockStart: {},
		blockEnd: {},
		blockHeight: {},
	},
	data() {
		return {};
	},
	computed: {
		blockDifference() {
			return this.blockEnd.toMinutes() - this.blockStart.toMinutes();
		},
		topDifference() {
			return (
				((this.courseStartEndTime - this.blockStart.toMinutes()) /
					this.blockDifference) *
				this.blockHeight
			);
		},
		courseStyle() {
			return {
				top: this.topDifference + "px",
			};
		},
		isVisible() {
			return (
				!this.blockStart.isAfter(new HourMinutes(this.courseStartEndTime)) &&
				!this.blockEnd.isBefore(new HourMinutes(this.courseStartEndTime))
			);
		},
		presentTime() {
			return new HourMinutes(this.courseStartEndTime).toString();
		},
	},
	methods: {},
};
</script>

<style lang="scss">
.timeline-item {
	position: absolute;
	right: 13px;
	margin-top: -8px;

	font-size: 14px;
	line-height: 16px;
	font-weight: normal;
	color: #666666;
}
</style>
